module.exports = __webpack_public_path__ + "static/media/contactanos.43ac2c93.png";